import React from 'react';
import { Card, Tag, Button, Space, Divider } from 'antd';
import {
  RightOutlined,
  CalendarOutlined,
  UsergroupAddOutlined,
  BookOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export function LearningPathCard({ path }) {
  const navigate = useNavigate();

  const getBadgeColor = (code) => {
    switch (code) {
      case 'LT1':
        return '#0284c7';
      case 'LT2':
        return '#16a34a';
      case 'LT3':
        return '#7c3aed';
      default:
        return '#0284c7';
    }
  };

  const items = path.items || [];

  return (
    <Card
      style={{
        borderRadius: 14,
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 14px rgba(0,0,0,0.04)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      }}
      styles={{ body: { padding: '24px 26px', display: 'flex', flexDirection: 'column', flex: 1 } }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.04)';
      }}
    >
      {/* Header Badge & Code */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <Tag
          style={{
            background: getBadgeColor(path.code),
            color: '#fff',
            border: 'none',
            fontWeight: 700,
            fontSize: 12,
            padding: '3px 10px',
            borderRadius: 6,
          }}
        >
          {path.code}
        </Tag>

        <Space size={6} style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>
          <CalendarOutlined style={{ color: '#0284c7' }} />
          <span>~{path.estimatedWeeks} tuần học</span>
        </Space>
      </div>

      {/* Title */}
      <h3 style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', lineHeight: 1.4, marginBottom: 8 }}>
        {path.title}
      </h3>

      {/* Target Audience */}
      {path.targetAudience && (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, fontSize: 13, color: '#475569', marginBottom: 14 }}>
          <UsergroupAddOutlined style={{ color: '#0284c7', marginTop: 3 }} />
          <span><strong>Đối tượng:</strong> {path.targetAudience}</span>
        </div>
      )}

      {/* Description */}
      <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6, flex: 1, marginBottom: 18 }}>
        {path.description}
      </p>

      <Divider style={{ margin: '12px 0 16px' }} />

      {/* Modules List in this Path */}
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#334155', textTransform: 'uppercase', marginBottom: 8, letterSpacing: '0.3px' }}>
          Danh sách {items.length} Module theo thứ tự học:
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {items.map((item, idx) => {
            const lesson = item.lesson;
            return (
              <Tag
                key={item.id || idx}
                color="blue"
                style={{
                  borderRadius: 6,
                  padding: '2px 8px',
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (lesson?.id) {
                    navigate(`/learn/paths/${path.id}/lessons/${lesson.id}`);
                  }
                }}
              >
                {idx + 1}. {lesson?.code || `B${idx + 1}`}
              </Tag>
            );
          })}
        </div>
      </div>

      {/* Action Button */}
      <Button
        type="primary"
        block
        icon={<BookOutlined />}
        style={{
          height: 42,
          fontWeight: 700,
          fontSize: 14,
          borderRadius: 8,
          background: getBadgeColor(path.code),
          borderColor: getBadgeColor(path.code),
        }}
        onClick={() => {
          if (items.length > 0 && items[0].lesson) {
            navigate(`/learn/paths/${path.id}/lessons/${items[0].lesson.id}`);
          }
        }}
      >
        Bắt Đầu Học Lộ Trình Này <RightOutlined />
      </Button>
    </Card>
  );
}
